import { Action } from "redux";

import { SET_FETCHING } from "./constants";

export interface IFetchingState {
    [key: string]: boolean;
}

export interface ISetFetchingAction extends Action<typeof SET_FETCHING> {
    readonly payload: {
        readonly key: string;
        readonly isFetching: boolean;
    };
}

export class ISetFetchingAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === SET_FETCHING;
    }
}
